/**
 * Routes list
 * Notification API
 */
let _prefix = '/notifications/v1'
let org_prefix = '/orgstructure/v1'
let stat_prefix = '/analytics/v1'

export default {
  // Список всех уведомлений
  list: _prefix + '/notifications',
  // Удаление уведомления
  delete: _prefix + '/notifications',
  // Редактирование уведомления
  update: _prefix + '/notifications',
  // Пометить все прочитанными
  viewedAll: _prefix + '/notifications/viewed-all',
  // Ответ на приглашение на пост
  acceptInvite: org_prefix +'/invite-accept',
  // Ответ на приглашение на пост
  acceptStatistic: stat_prefix + '/invite-accept',
}



// WEBPACK FOOTER //
// ./src/apps/notifications/api/routes.js